function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.2372 4.97049V4.17049C10.2372 2.17049 8.73721 0.495489 6.83721 0.320489C5.78721 0.220489 4.73721 0.595489 3.96221 1.29549C3.21221 1.99549 2.76221 2.97049 2.76221 3.99549V4.94549C1.26221 5.17049 0.137207 6.47049 0.137207 8.02049V12.7455C0.137207 14.3705 1.46221 15.6955 3.08721 15.6955H9.91221C11.5372 15.6955 12.8622 14.3705 12.8622 12.7455V7.99549C12.8872 6.47049 11.7372 5.22049 10.2372 4.97049ZM4.56221 1.94549C5.16221 1.39549 5.93721 1.12049 6.76221 1.19549C8.21221 1.32049 9.36221 2.62049 9.36221 4.17049V4.92049H3.66221V3.99549C3.66221 3.22049 3.98721 2.47049 4.56221 1.94549ZM12.0122 12.7205C12.0122 13.8705 11.0872 14.7955 9.93721 14.7955H3.08721C1.93721 14.7955 1.01221 13.8705 1.01221 12.7205V8.04549C1.01221 6.82049 2.01221 5.79549 3.26221 5.79549H9.73721C10.9872 5.79549 12.0122 6.77049 12.0122 7.99549V12.7205Z",
  fill: "#323F4B"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M6.51226 8.87048C6.26226 8.87048 6.06226 9.07048 6.06226 9.32048V9.97048V10.6205V11.9455C6.06226 12.1955 6.26226 12.3955 6.51226 12.3955C6.76226 12.3955 6.96226 12.1955 6.96226 11.9455V10.6205V9.97048V9.32048C6.96226 9.07048 6.76226 8.87048 6.51226 8.87048Z",
  fill: "#323F4B"
});
function SvgIconLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLock);
export default __webpack_public_path__ + "static/media/icon-lock.a664ea787d76d1e8556817edbb5972db.svg";
export { ForwardRef as ReactComponent };